import { render, staticRenderFns } from "./ProjectIcon.vue?vue&type=template&id=085432aa&"
import script from "./ProjectIcon.vue?vue&type=script&lang=js&"
export * from "./ProjectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports